import {IHttpClient} from "../..";
import {PagedResultSet} from "../../../models/api/common";
import APIBase from "../APIBase";
import BlogFilter from "../../../filters/BlogFilter";
import {BlogModel, CreateBlogModel, UpdateBlogModel} from "../../../models/api/blogs";

// OfferAPI is a translation layer, it uses the same BlogsController on the webAPI

export default class OfferAPI extends APIBase {
    constructor(httpClient: IHttpClient) {
        super(httpClient);
    }

    GetOfferBySlug(slug: string): Promise<BlogModel> {
        return this.GET({
            Path: `/blogs/${slug}`
        })
    }

    CreateOffer(model: CreateBlogModel): Promise<BlogModel> {
        return this.POST({
            Path: '/blogs',
            Body: model
        })
    }

    UpdateOffer(blogId: string, model: UpdateBlogModel): Promise<BlogModel> {
        return this.PATCH({
            Path: `/blogs/${blogId}`,
            Body: model
        })
    }

    DeleteOffer(blogId: string): Promise<boolean> {
        return this.DELETE({
            Path: `/blogs/${blogId}`
        })
    }

    GetOffersForConsole(filter: BlogFilter): Promise<PagedResultSet<BlogModel>> {
        return this.GET({
            Path: '/blogs',
            QueryParams: filter.ToQueryParams()
        })
    }

    GetOfferForPrivate(slug: string): Promise<BlogModel> {
        return this.GET({
            Path: `/blogs/${slug}/member`,
        })
    }

    GetOffersForPublic(filter: BlogFilter): Promise<PagedResultSet<BlogModel>> {
        return this.GET({
            Anon: true,
            Path: '/blogs',
            QueryParams: filter.ToQueryParams()
        })
    }
}
